import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { type DataTableEmptyState } from "src/components/DataTable";
import { useDataTableContext } from "src/components/DataTableContext";

interface DataTableEmptyProps {
  state?: DataTableEmptyState;
}

export function DataTableEmpty(props: DataTableEmptyProps) {
  const { t } = useTranslation();
  const dataTable = useDataTableContext();
  const action = props.state?.action ?? dataTable.toolbarTrailing;

  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12 text-center">
      <Icon
        name={
          dataTable.hasActiveFilters
            ? "tabler-search"
            : (props.state?.icon ?? "tabler-list")
        }
        className="size-8 text-muted-foreground"
      />
      <div className="text-sm font-semibold">
        {dataTable.hasActiveFilters
          ? t("dataTable.empty.title")
          : (props.state?.title ?? t("dataTable.empty.noData"))}
      </div>
      {dataTable.hasActiveFilters ? (
        <>
          <div className="text-sm text-muted-foreground">
            {t("dataTable.empty.hint")}
          </div>
          <Button
            variant="outline"
            size="sm"
            className="mt-2"
            onClick={dataTable.clearFilters}
          >
            {t("dataTable.empty.reset")}
          </Button>
        </>
      ) : (
        <>
          {props.state?.description ? (
            <div className="max-w-md text-sm text-muted-foreground">
              {props.state.description}
            </div>
          ) : null}
          {action ? <div className="mt-2">{action}</div> : null}
        </>
      )}
    </div>
  );
}
